const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class GiftWithPurchaseCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleDrawerOpen = this.handleDrawerOpen.bind(this)

    this.externalEls.trigger.element.addEventListener(
      'click',
      this.handleDrawerOpen,
    )
  }

  handleDrawerOpen () {
    setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 100)
  }

  setupCarousel () {
    this.dragStarted = this.dragStarted.bind(this)
    this.animationEnded = this.animationEnded.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 2.08,
          spacing: 1,
        },
        dragStarted: this.dragStarted,
        animationEnded: this.animationEnded,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.prev?.element,
        }),
      ],
    )
  }

  dragStarted () {
    this.setAttribute('moving', '')
  }

  animationEnded () {
    this.removeAttribute('moving')
  }
}

if (!customElements.get('gift-with-purchase-carousel')) {
  customElements.define('gift-with-purchase-carousel', GiftWithPurchaseCarousel)
}
